import React, {useState} from "react";
import {BackGround, ButtonLogin, CenterInputs, DivForm, DivText, ImagemLogin, InputsContainer, InputsContainerButtons, LinkLogin, PaperLogin, TextFieldLogin} from "./styles";
import {InputAdornment} from "@mui/material";
import {RxPerson} from "react-icons/rx";
import {AiOutlineLock} from "react-icons/ai";
import {useFormik} from "formik";
import Toast from "../../../components/toast";
import {IUser, userValidationSchema} from "../../../models/auth";
import {useAuthContext} from "../../../contexts/auth-context";
import {Navigate, useNavigate} from "react-router-dom";
import ExceptionUtils from "../../../utils/ExceptionUtils";

const Login = () => {

  const {isAuthenticated, login} = useAuthContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    form.validateForm(form.values).then(errors => {
      Object.entries(errors).map((error) => Toast.error(error[1]));
    });
  };

  const form = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: userValidationSchema,
    onSubmit: async (values: IUser) => {
      try {
        setLoading(true);
        await login(values);
        navigate("/dashboard");
      } catch (e) {
        ExceptionUtils.defaultExceptionHandler(e);
      } finally {
        setLoading(false);
      }
    },
    validateOnChange: false,
  });

  if (isAuthenticated) return <Navigate replace to="/dashboard"/>;
  return (
    <>
      <BackGround>
        <PaperLogin>
          <ImagemLogin/>
          <DivForm onSubmit={form.handleSubmit}>
            <DivText>
              <CenterInputs>
                <InputsContainer>
                  <TextFieldLogin
                    fullWidth
                    label="Usuário"
                    name={"username"}
                    id={"username"}
                    variant="standard"
                    value={form.values.username}
                    onChange={form.handleChange}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <RxPerson fontSize={25}/>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextFieldLogin
                    fullWidth
                    name={"password"}
                    id={"password"}
                    label="Senha"
                    variant="standard"
                    type={"password"}
                    value={form.values.password}
                    onChange={form.handleChange}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AiOutlineLock fontSize={25}/>
                        </InputAdornment>
                      ),
                    }}
                  />
                </InputsContainer>
              </CenterInputs>
              <InputsContainerButtons>
                <ButtonLogin type={"submit"} onClick={validateForm} disabled={loading}> Login </ButtonLogin>
                <LinkLogin onClick={() => navigate("/recuperar-senha")}>
                  Esqueci minha senha!
                </LinkLogin>
              </InputsContainerButtons>
            </DivText>
          </DivForm>
        </PaperLogin>
      </BackGround>
    </>
  );
};

export default Login;
